//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.InspectionTemplateOptionsQuery_ResponseAdapter
import com.wintermar.inspection.graphql.selections.InspectionTemplateOptionsQuerySelections
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public class InspectionTemplateOptionsQuery() : Query<InspectionTemplateOptionsQuery.Data> {
  override fun equals(other: Any?): Boolean = other != null && other::class == this::class

  override fun hashCode(): Int = this::class.hashCode()

  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    // This operation doesn't have any variable
  }

  override fun adapter(): Adapter<Data> = InspectionTemplateOptionsQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = InspectionTemplateOptionsQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(InspectionTemplateOptionsQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val inspectionTemplateOptions: List<InspectionTemplateOption>,
  ) : Query.Data

  public data class InspectionTemplateOption(
    public val label: String,
    public val answerType: InspectionAnswerType,
    public val order: Int,
    public val id: Any,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "5541343cc81bde334df067ed95838f5337db5822cd940c0b2a025a470901acb2"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query inspectionTemplateOptions {
     *   inspectionTemplateOptions {
     *     label
     *     answerType
     *     order
     *     id
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query inspectionTemplateOptions { inspectionTemplateOptions { label answerType order id } }"

    public const val OPERATION_NAME: String = "inspectionTemplateOptions"
  }
}
